import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import Icon from './Icon';

function ThemeToggle() {
  const { isDark, toggleTheme, manualOverride } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-zinc-100 dark:bg-zinc-800 hover:bg-zinc-200 dark:hover:bg-zinc-700 text-zinc-900 dark:text-zinc-100 transition-colors"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={manualOverride ? (isDark ? 'Dark mode (manual)' : 'Light mode (manual)') : 'Auto mode (follows sunset)'}
    >
      {isDark ? (
        <Icon emoji="☀️" size="text-xl" />
      ) : (
        <Icon emoji="🌙" size="text-xl" />
      )}
    </button>
  );
}

export default ThemeToggle;

